const riskLevelModel = () => {
    return {
        riskLevel : [
            {
                id: '1',
                option: 'Risk Level I',
                subtitle: 'Can understand and be placed in jobs with potencial occupational',	
            },
            {
                id: '2',
                option: 'Risk Level II',
                subtitle : 'Would understand the need to avoid contact with blood or OPIM but should be placed in a job without exposure risk',
                includeComments : true,
                commentsAreRequired : true,
                commentMapTo : 'riskLevel2Comments',
                isRequiredValid : (data) =>{
                    return !data.riskLevel || (data.riskLevel && data.riskLevel.id !== '2') || (data.riskLevel && data.riskLevel.id === '2' && data.riskLevel2Comments && data.riskLevel2Comments.trim() !== '');
                }
            },
            {
                id: '3',
                option: 'Risk Level III',
                subtitle: 'Should be placed in a low-risk situation',
                includeComments : true,
                commentsAreRequired : true,
                commentMapTo : 'riskLevel3Comments',
                isRequiredValid : (data) =>{
                    
                    return !data.riskLevel || (data.riskLevel && data.riskLevel.id !== '3') || (data.riskLevel && data.riskLevel.id === '3' && data.riskLevel3Comments && data.riskLevel3Comments.trim() !== '');
                }
            }
        ]
    };
};

export default riskLevelModel;
